import {Col, Row} from 'antd';
import {useIntl} from 'react-intl';
import {Input, Switch, TreeSelect} from 'formik-antd';
import FormItem from '../../../../../../../shared/components/form-item';
import {useEffect, useState} from 'react';
import IntlMessages from '../../../../../../../domain/utility/IntlMessages';
import {useFormikContext} from 'formik';
import {useParams} from 'react-router-dom';
import MainUtils from 'src/shared/utils/main';
import {
  getLocaleValue,
  handleChangeLocales,
} from 'src/shared/functions/change-locales';

interface IAttributeInfoStandardProps {
  categoriesList?: any;
  setIsAvailableAllCategories?: any;
  categoryLoading?: boolean;
  code: string;
}

const AttributeInfoStandard = (props: IAttributeInfoStandardProps) => {
  const {categoriesList, setIsAvailableAllCategories, categoryLoading, code} =
    props;

  const {messages} = useIntl();

  const {id} = useParams();

  const [categoriesTree, setCategoriesTree] = useState<any[]>([]);

  const [isAvailableForAllCategories, setIsAvailableForAllCategories] =
    useState(false);

  const {setFieldValue, values} = useFormikContext<any>();

  useEffect(() => {
    if (categoriesList?.length > 0) setCategoriesTree(categoriesList);
  }, [categoriesList]);

  useEffect(() => {
    if (values) {
      setIsAvailableAllCategories(values.isAvailableForAllCategories);
      setIsAvailableForAllCategories(values.isAvailableForAllCategories);
    }
  }, [values]);

  useEffect(() => {
    if (isAvailableForAllCategories) {
      setFieldValue('selectedCategoryIds', undefined);
    }
  }, [isAvailableForAllCategories]);

  return (
    <>
      <Row gutter={[0, 20]}>
        <Col span={24}>
          <FormItem
            name='name'
            label={messages['specificationAttributes.create.name'].toString()}
            titleTooltip={messages[
              'tooltip.specificationAttributes.create.name'
            ].toString()}
            isTooltip
            fieldCommponent={
              <Input
                name='name'
                value={getLocaleValue(values?.locales, code, 'name')}
                onChange={(value) =>
                  handleChangeLocales(
                    values?.locales,
                    setFieldValue,
                    `locales`,
                    code,
                    'name',
                    value.target.value,
                  )
                }
              />
            }
          />
        </Col>
        {!id && (
          <Col span={24}>
            <FormItem
              name='defaultOptionName'
              label={messages[
                'specificationAttributes.create.defaultOptionName'
              ].toString()}
              fieldCommponent={<Input name='defaultOptionName' />}
            />
          </Col>
        )}

        <Col span={24}>
          <FormItem
            name='isAvailableForAllCategories'
            label={messages[
              'specificationAttributes.create.isAvailableForAllCategories'
            ].toString()}
            fieldCommponent={
              <Switch
                name='isAvailableForAllCategories'
                checkedChildren={<IntlMessages id='common.active' />}
                unCheckedChildren={<IntlMessages id='common.inactive' />}
                onChange={(value) => {
                  setIsAvailableForAllCategories(value);
                }}
              />
            }
          />
        </Col>

        {!isAvailableForAllCategories && (
          <Col span={24}>
            <FormItem
              name='selectedCategoryIds'
              label={messages[
                'specificationAttributes.create.selectedCategoryIds'
              ].toString()}
              fieldCommponent={
                <TreeSelect
                  name='selectedCategoryIds'
                  showSearch
                  className='width-100'
                  allowClear
                  loading={categoryLoading}
                  filterTreeNode={(input: any, option: any) =>
                    MainUtils.filterOptions(input, option, true)
                  }
                  multiple
                  treeData={categoriesTree}
                  showCheckedStrategy='SHOW_ALL'
                />
              }
            />
          </Col>
        )}
      </Row>
    </>
  );
};

export default AttributeInfoStandard;
